import useAuth from "./useAuth";
import LoginPage from "../pages/LoginPage";

export default function ProtectedRoute({ children }) {

  const { token } = useAuth();

  if (!token) return <LoginPage />;

  return children;
}
